import { FieldError, FieldStatus } from "@/framework/base/components/FieldInfo";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    props: {
        value: {
            type: Object as PropType<boolean | null>,
            required: true
        },
        libelle: {
            type: String
        },
        required: {
            type: Boolean
        },
        readOnly: {
            type: Boolean
        },
        contextId: {
            type: Number,
            required: true
        },
        dataTable: {
            type: Number
        },
        showMissing: {
            type: Boolean
        }
    },
    data() {
        const initValue = false as boolean | null;

        return {
            initValue,
            status: new FieldStatus(false, false, 0)
        };
    },
    created(): void {
        this.initValue = this.value;
        this.status.objId = this.contextId;
    },
    methods: {
        setInitValue(value: boolean | null): void {
            this.initValue = value;
            this.status.objId = this.contextId;
        },
        save(): void {
            this.initValue = this.value;
            this.status.clear(this.contextId);
            this.$emit('status', this.status);
        },
        setUpdated(value: boolean): void {
            this.status.updated = value != this.initValue;
            this.$emit('update:value', value);
            this.$emit('status', this.status);
        },
        setError(value: FieldError): void {
            this.status.error = value.error;
            this.$emit('status', this.status);
        }
    }
})
